import type { CompanyEvent } from "@/modules/companies/client/api/types"

import { isAfter, isBefore, subDays } from "date-fns"

type getEventCardTopTagTypes = {
  showLastSlotsTopTag: boolean
  showLessThanThreeDaysTopTag: boolean
}
export const getEventCardTopTag = (event: CompanyEvent): getEventCardTopTagTypes => {
  const { maxTicketCount, remainingTicketCount, startDate } = event

  const eventHasSlots = maxTicketCount !== 0
  const eventHasLastSlots = eventHasSlots && !!remainingTicketCount && remainingTicketCount < 10
  const eventHasFullSlots = eventHasSlots && remainingTicketCount === 0
  const eventInProgress = isBefore(new Date(startDate), new Date())
  const eventInThreeDays = isAfter(new Date(), subDays(new Date(startDate), 3))

  const showLastSlotsTopTag = eventHasLastSlots && !eventHasFullSlots
  const showLessThanThreeDaysTopTag = !eventInProgress && eventInThreeDays && !eventHasLastSlots

  return {
    showLastSlotsTopTag,
    showLessThanThreeDaysTopTag,
  }
}
